$ = require 'jquery'
Alerts = require 'app/scripts/views/lib/alerts'
Auth = require 'app/scripts/db/auth'
Backgrounds = require 'app/scripts/data/backgrounds'
BoardDisplayHelpers = require 'app/scripts/views/internal/board-display-helpers'
Controller = require 'app/scripts/controller'
CreateOrgView = require 'app/scripts/views/organization/create-org-view'
ConvertToTemplateView = require 'app/scripts/views/board/convert-board-template-view'
Language = require('@trello/locale')
lastOrganization = require('app/common/lib/util/last-organization').default
ModelLoader = require 'app/scripts/db/model-loader'
NewBoardHelperAddOrgView = require 'app/scripts/views/board/new-board-helper-add-org-view'
PopOver = require 'app/scripts/views/lib/pop-over'
Promise = require 'bluebird'
{ Storage } = require '@trello/storage'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
_ = require 'underscore'
templates = require 'app/scripts/views/internal/templates'
{ track, trackUe } = require '@trello/analytics'
l = require 'app/scripts/lib/localize'
{ featureFlagClient } = require '@trello/feature-flag-client'
boardMenuVisTemplate = require 'app/scripts/views/templates/board_menu_vis'
isDesktop = require('@trello/browser').isDesktop()

LastOrganization = lastOrganization Storage
TEMPLATES_ALERT_TIMEOUT = 1000

module.exports = class CopyBoardView extends View

  events:
    'change select[name="org-id"]': 'changeOrg'
    'click .js-helper-add-org': 'helperAddOrg'
    'submit form': 'submit'
    'click .js-submit': 'submit'
    'click .js-create-org': 'newOrg'
    'click .js-change-vis': 'openChangeVis'
    'click .js-select': 'selectVis'
    'click .js-confirm-public': 'confirmPublic'
    'click .js-cancel-public': 'cancelPublic'
    'click .js-open-convert': 'openConvertToTemplate'

  initialize: ({ boardNameInputValue, toTemplate }) ->
    @boardNameInputValue = boardNameInputValue
    @toTemplate = toTemplate

  getData: ->
    @loading = true
    ModelLoader.loadBoardMinimal(@model.get('id'))
      .finally =>
        @loading = false
        @render()

  getViewTitle: =>
    if @model.isTemplate()
      return l(['view title', 'create board from template'])

    if @toTemplate
      return l(['view title', 'make template'])

    l(['view title', 'copy board'])

  getOrganization: ->
    switch @model.typeName
      when 'Organization'
        @model
      when 'Board'
        @model.getOrganization()
      when 'Member'
        null

  getDefaultIdOrganization: (idOrgs) ->
    if idOrgs.length == 0
      return null

    if @options.useLastOrganization
      if idOrgs.length == 1
        return idOrgs[0]

      idLastOrganization = LastOrganization.get()
      if idLastOrganization == LastOrganization.NO_ORGANIZATION
        null
      else if idLastOrganization? && idLastOrganization in idOrgs
        idLastOrganization
      else
        # Use the most recently created org
        idOrganization = null
        for id in idOrgs when !idOrganization? || id > idOrganization
          idOrganization = id
        idOrganization
    else
      if (idOrganization = @getOrganization()?.id)?
        idOrganization
      else
        null

  render: ->
    me = Auth.me()

    idOrganization = @getDefaultIdOrganization(me.organizationList.pluck('id'))

    orgs = me.organizationList
    isPublicTemplate = @model.get('prefs').isTemplate && @model.get('prefs').permissionLevel == 'public'
    hasEnterprise = @model.get('enterpriseOwned')
    isPaidManagedEntMember = me.isPaidManagedEntMember()
    if ((hasEnterprise || isPaidManagedEntMember) && !isPublicTemplate)
      # We may or may not know anything about the enterprise. If we do, restrict copies
      # to that enterprise. If we don't, at least restrict the dropdown to enterprise
      # teams. If the user is associated with multiple enterprises, it's possible they
      # could select the wrong one, but at least the server will enforce the content
      # restrictions
      enterprise = @model.getEnterprise()
      if enterprise
        orgs = orgs.filter((org) -> org.get('idEnterprise') == enterprise.get('id'))
      else if isPaidManagedEntMember
        orgs = orgs.filter((org) -> org.belongsToRealEnterprise())
      else
        orgs = orgs.filter((org) -> org.get('idEnterprise'))

    hasOrg = idOrganization?
    org = if hasOrg then @modelCache.get('Organization', idOrganization) else null

    orgs = orgs.map (org) ->
      _.extend org.toJSON(), {
        selectOrg: org.id == idOrganization
      }

    # We'll only show the "(none)" option for enterprise boards if they're explicitly
    # owned by the enterprise, i.e. if their `idEnterprise` field is set. When that field is set we know
    # that explicit owneship is turned on for that enterprise on the backend so the board will retain
    # the enterprise owneship status when moved to a user's "private space".
    isExplicitBoardOwnershipOn = featureFlagClient.get('enterprise.explicit-board-ownership-web', false)
    showPrivateBoardsOptionForEntBoards = isExplicitBoardOwnershipOn && @model.get('idEnterprise')?

    data = {
      orgs
      hasOrg
      canAddToOrgs: orgs.length != 0
      willRemovePowerUps: @model.powerUpsCount() > me.getPowerUpsLimit()
      isDesktop: isDesktop
      loading: @loading
      hasEnterprise
      toTemplate: @toTemplate
      showPrivateBoardsOptionForEntBoards
    }
    if enterprise
      data.enterpriseName = enterprise.get('displayName')
    # Yes, this is implicit coupling to the number of placeholders
    # we have in the strings file. If we ever have another nondeterministic
    # string, we can think about doing this more formally...
    placeholderKey = Math.floor(Math.random() * 13).toString()
    data.placeholder = l(['board name placeholder', placeholderKey])

    data.publicConfirmationText = l(['confirm', 'public board confirmation', 'text'])
    data.publicConfirmationConfirm = l(['confirm', 'public board confirmation', 'confirm'])
    data.publicConfirmationCancel = l(['cancel'])
    data.isTemplate = @model.isTemplate()

    if @boardNameInputValue
      data.boardNameInputValue = @boardNameInputValue

    data.pLevel = 'private'
    if @model.owned()
      data.pLevel = @model.get('prefs').permissionLevel
    else if hasOrg
      data.pLevel = 'org'

    if @options?.newOrgBoard
      data.hideOrg = true

    @$el.html(
      templates.fill(
        'board_copy',
        data
      )
    )

    @checkBoardPermissions()

    @

  checkBoardPermissions: ->
    orgId = @$('select[name="org-id"]').val()
    if !orgId
      @renderBoardVisChooser()
      return

    @loadOrg(orgId)
    .then (org) =>
      # Show the board limits CTA
      if org?.isAtOrOverFreeBoardLimit()
        @$('.js-board-limits-upgrade-ad').removeClass('hide')
        @$('.js-target-team').text(org.get('displayName'))
        @$('.js-upgrade-link').attr('href', org.getBillingUrl())
        @disableSubmit()

      else
        @renderBoardVisChooser()

  loadOrg: (orgId) ->
    Promise.try =>
      if orgId
        org = @modelCache.get('Organization', orgId)
        if org? then org else ModelLoader.loadOrganizationMinimal orgId
      else null

  renderBoardVisChooser: (selectedVis) ->
    @$('.js-permissions').removeClass('hide')
    orgId = @$('select[name="org-id"]').val()

    visData =
      isNewBoard: true
      canChange: true

    @disableSubmit()

    localizedParagraph = (key) -> "<p>#{l(key)}</p>"
    @$('.js-vis-display').html localizedParagraph('checking visibility permissions')

    @loadOrg(orgId)
    .then (org) =>
      if org?
        enterprise = org?.getEnterprise()
        if !@canChangeOrg(org, selectedVis)
          selectedVis = null

        _.extend visData,
          hasOrg: true
          orgName: org.get('displayName')
          hasSuperAdmins: org.isFeatureEnabled('superAdmins')
          privateRestricted: !@canChangeOrg(org, 'private')
          orgRestricted: !@canChangeOrg(org, 'org')
          enterpriseRestricted: !@canChangeOrg(org, 'enterprise')
          publicRestricted: !@canChangeOrg(org, 'public')
          hasEnterprise: enterprise?
          enterpriseName: enterprise?.get('displayName')

      defaultVis =
        if org? && @canChangeOrg(org, 'org')
          if @model.isPrivate()
            'private'
          else
            'org'
        else if @toTemplate
          'public'
        else
          'private'
      visData.current = selectedVis ? defaultVis

      { org, visData }

    .then ({ org, visData }) =>
      # It's possible that there's no valid permission level for us, in which
      # case we can't create a board at all
      if org? && visData.privateRestricted && visData.orgRestricted && visData.enterpriseRestricted && visData.publicRestricted
        $noValidPrivs = @$('.js-no-valid-org-privs')
        if org.owned()
          $noValidPrivs.html l('board create restriction admin', { urlSettings: "/#{ org.get('name') }/account" })
        else
          $noValidPrivs.html l('board create restriction not admin')
        $noValidPrivs.removeClass('hide')
        @$('.js-vis-chooser,.js-vis-display').addClass('hide')

      visData.toTemplate = @toTemplate

      @$('.js-vis-chooser').html(boardMenuVisTemplate(visData))

      previousLevel = @getPermissionLevel()
      currentLevel = visData.current

      # Only show confirmation if changing visibility to public
      if previousLevel != currentLevel && currentLevel == 'public'
        @openPublicConfirmation()
      else
        @setPermissionLevel(currentLevel)
        @renderVisDisplay(currentLevel)
        @enableSubmit()

    .done()

    @

  enableSubmit: ->
    @$('.js-submit').removeClass('disabled')

  disableSubmit: ->
    @$('.js-submit').addClass('disabled')

  renderVisDisplay: (vis) ->
    @$('.js-vis-display').html templates.fill 'board_copy_vis',
      visIconClass: BoardDisplayHelpers.getPermLevelIconClass(vis)
      visDisplayText: l(['board perms', vis, 'name'])
      toTemplate: @toTemplate

  resetVisChooser: ->
    @$('.js-no-valid-org-privs').addClass('hide')
    return

  openPublicConfirmation: ->
    @$('.js-vis-display').addClass('hide')
    @$('.js-confirm-public-message').removeClass('hide')

  hidePublicConfirmation: ->
    @$('.js-confirm-public-message').addClass('hide')
    @$('.js-vis-display').removeClass('hide')

  confirmPublic: ->
    @setPermissionLevel('public')
    @renderVisDisplay('public')
    @hidePublicConfirmation()
    @enableSubmit()
    trackUe('copy board menu', 'sets', 'board visibility', '', 'to public', '', { change: 1 })

  cancelPublic: ->
    previousPermissionLevel = @getPermissionLevel()
    @renderBoardVisChooser(previousPermissionLevel)
    @hidePublicConfirmation()
    trackUe('copy board menu', 'cancels', 'board visibility', '', 'to public', '', { change: 0 })

  openChangeVis: (e) ->
    Util.stop(e)
    @$('.js-vis-display').addClass('hide')
    @$('.js-vis-chooser').removeClass('hide')
    @$('.js-confirm-public-message').addClass('hide')

    return

  selectVis: (e) ->
    Util.stop(e)

    $target = $(e.target).closest('.js-select')
    if $target.hasClass('disabled')
      return

    @$('.js-vis-display').removeClass('hide')
    @$('.js-vis-chooser').addClass('hide')

    originalVis = @getPermissionLevel()
    vis = $target.attr('name')
    @renderBoardVisChooser(vis)

    # There is a second confirmation to change board visibility to public
    if vis != 'public'
      trackUe('copy board menu', 'sets', 'board visibility', "to #{vis}", '', '', {
        boardId: @model.id,
        teamId: @model.getOrganization()?.id,
        isTemplate: @model.isTemplate(),
        change: if originalVis != vis then 1 else 0
      })

    return

  setPermissionLevel: (permissionLevel) ->
    @$('input[name="permissionLevel"]').val(permissionLevel)

  getPermissionLevel: ->
    @$('input[name="permissionLevel"]').val() ? ""

  canChangeOrg: (org, setting) ->
    org.canSetVisibility setting

  allowBoardCopy: ->
    @$('.js-board-limits-upgrade-ad').addClass('hide')
    @resetVisChooser()
    @$('.js-vis-display').removeClass('hide')
    @$('.js-vis-chooser').addClass('hide')
    @renderBoardVisChooser()

  changeOrg: (e) ->
    orgId = e.target.value

    trackUe('copy board menu', 'sets', 'board organization', '', '', '', {
      boardId: @model.id,
      teamId: orgId,
      isTemplate: @model.isTemplate()
    })

    @hidePublicConfirmation()

    # personal boards have no restrictions
    if !orgId
      @allowBoardCopy()
      return

    # Use the permission check as a loading state when checking
    # the board limit
    localizedParagraph = (key) -> "<p>#{l(key)}</p>"
    @$('.js-vis-display').html localizedParagraph('checking visibility permissions')

    # Hide any existing CTAs while we determine if the new ones are necessary
    @$('.js-board-limits-upgrade-ad').addClass('hide')

    @disableSubmit()
    @loadOrg(orgId)
    .then (org) =>
      # Show the board limits CTA
      if org?.isAtOrOverFreeBoardLimit()
        @$('.js-permissions').addClass('hide')
        @$('.js-board-limits-upgrade-ad').removeClass('hide')
        @$('.js-target-team').text(org.get('displayName'))
        @$('.js-upgrade-link').attr('href', org.getBillingUrl())

      else
        @allowBoardCopy()

  helperAddOrg: (e) ->
    Util.stop(e)
    PopOver.pushView
      view: new NewBoardHelperAddOrgView({ @model, @modelCache })
    trackUe('copy board menu', 'opens', 'add org helper', '', '', '', {
      boardId: @model.id,
      teamId: @getOrganization()?.id,
      isTemplate: @model.isTemplate()
    })
    return

  defaultBackgroundColor: ->
    if Language.usesEnglish()
      now = new Date()
      month = now.getMonth()
      date = now.getDate()

      if month == 2 && date == 17
        # It's March 17th, St. Patricks Day
        return 'green'

    'blue'

  submit: (e) ->
    Util.stop(e)

    return if @$('.js-submit').hasClass('disabled')

    # Figure out the name they want, and abort if it's blank
    $name = @$('input[name="name"]')
    name = $name.val().trim()
    if name == ''
      $name.focus().select()
      return

    idOrganization = @$('select[name="org-id"]').val() ? ""

    LastOrganization.set(idOrganization)

    # Data that we'll use in the body of the POST to create the board
    initialData =
      name: name
      idOrganization: idOrganization

    permissionLevel = @$('input[name="permissionLevel"]').val()

    backgroundColor = @defaultBackgroundColor()

    ownedBoards = _.filter Auth.me().boardList.models, (board) -> board.owned()

    # Data that we're going to send in the create request; not all of the
    # fields will be board attributes
    requestData = _.extend({
      prefs_permissionLevel: permissionLevel
    }, initialData)

    if @model.isTemplate()
      requestData = _.extend({
        prefs_isTemplate: false,
      }, requestData)

    if @toTemplate
      requestData = _.extend({
        prefs_isTemplate: true
        idBoardSource: @model.id
        keepFromSource: 'cards'
      }, requestData)

    requestData.idBoardSource = @model.id
    requestData.keepFromSource =
      @$('input:checkbox:checked').map(-> this.name).get().join()

    newBoard = Auth.me().boardList.create initialData, {
      @modelCache
      requestData: requestData
      success: (board) =>
        Alerts.hide('copying')
        Alerts.hide('templates')

        if @toTemplate && !Auth.me().isDismissed('made-first-template')
          Auth.me().dismiss('made-first-template')

        # @toTemplate is undefined, @model.isTemplate() is true, when creating a board from template banner
        # @toTemplate is true, @model.isTemplate() is false, when creating a template via create button
        # @toTemplate is undefined, @model.isTemplate() is undefined, when copying a board
        if !@toTemplate && @model.isTemplate()
          trackingCategory = 'copy template menu'
          trackingDirObj = 'new board'
        else if @toTemplate && !@model.isTemplate()
          trackingCategory = 'create template menu'
          trackingDirObj = 'template'
        else
          trackingCategory = 'copy board menu'
          trackingDirObj = 'new board'

        trackUe(trackingCategory, 'creates', trackingDirObj, '', '', 'by clicking Create button', {
          boardId: board.id
          sourceBoardId: @model.id,
          teamId: idOrganization,
          fromTemplate: @model.isTemplate()
        })

        # this fixes an issue with idBoards not being updated at the time that
        # the board gets rendered and the client thinking the member is not on
        # the board
        if board.id !in (currentBoards = Auth.me().get('idBoards'))
          Auth.me().set('idBoards', currentBoards.concat(board.id))

        # We have to wait until we the board id back before we can
        # display the board
        Controller.displayBoard({
          idBoard: board.id
        }).done()

        return
      error: ->
        Alerts.flash('could not create board', 'error', 'create error')
    }

    if @model.isTemplate()
      Alerts.show('creating-board', 'info', 'templates')
    else if @toTemplate
      Alerts.show('creating-template', 'info', 'templates', TEMPLATES_ALERT_TIMEOUT)
    else
      Alerts.show('copying', 'info', 'copying')

    PopOver.hide()

  newOrg: (e) ->
    createOpts = {}

    if Auth.me().isPaidManagedEntMember()
      createOpts.isEnterprise = true

    trackingOpts = { category: 'board', method: 'by clicking create team in copy board menu' }
    Util.stop(e)
    PopOver.pushView
      view: new CreateOrgView({ @model, @modelCache, createOpts, trackingOpts })
    trackUe('copy board menu', 'opens', 'create org menu', '', '', '', {
      boardId: @model.id,
      teamId: @getOrganization()?.id,
      isTemplate: @model.isTemplate()
    })
    return

  openConvertToTemplate: (e) ->
    Util.stop(e)
    PopOver.pushView
      view: new ConvertToTemplateView({
        @model,
        @modelCache,
        hasDismissedFirstTemplateMessage: Auth.me().isDismissed('made-first-template'),
        dismissMessage: -> !Auth.me().isDismissed('made-first-template') && Auth.me().dismiss('made-first-template')
      })
